import type { RoomFilter } from '@tyro/api';

export const roomKeys = {
  all: ['coreRoomPool'] as const,
  coreRooms: (filter?: RoomFilter) => [...roomKeys.all, filter] as const,
  coreRoomPools: () => [...roomKeys.all, 'coreRoomPools'] as const,
  roomPoolsSelect: () => [...roomKeys.all, 'roomPoolsSelect'] as const,
  createOrUpdateRoom: () => [...roomKeys.all, 'createOrUpdateRoom'] as const,
  createOrUpdateRoomPools: () =>
    [...roomKeys.all, 'createOrUpdateRoomPools'] as const,
};
